var React = require('react');

function ArrowUp (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"#818A91","fillRule":"evenodd","d":"M5.422.127l4.812 5.913a.352.352 0 0 1 .046.369.345.345 0 0 1-.311.2H7.562v8a.346.346 0 0 1-.343.348H3.094a.345.345 0 0 1-.344-.348v-8H.344A.343.343 0 0 1 0 6.26a.35.35 0 0 1 .078-.221L4.891.127a.343.343 0 0 1 .53 0"}));
}

ArrowUp.defaultProps = {"width":"11","height":"15","viewBox":"0 0 11 15"};

module.exports = ArrowUp;

ArrowUp.default = ArrowUp;



// WEBPACK FOOTER //
// ./src/Assets/Icons/arrow-up.svg